import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { NextSeo } from 'next-seo';
import { useContext, useEffect } from 'react';

import CanonicalURL from '@/components/common/Canonical';
import { getSEOProps } from '@/components/utility';
import HeaderFooterContext from '@/context/HeaderFooterContext';
import { getFaqsData } from '@/services/faqs/faq';
import { getInnerPagesWithDefaultLocale } from '@/services/home';
import SetBrandsContext from '@/services/home/setBrands';
import {
  BRAND_NAME_EN,
  BRAND_NAME_FR,
  FAQ_EN,
  FAQ_FR,
  SELF_STORAGE_FAQ,
  SELF_STORAGE_FAQ_FR,
} from '@/utils/constants';

const AskedQuestions = dynamic(
  () => import('@/components/faqs/askedQuestions')
);
const FaqsBanner = dynamic(() => import('@/components/faqs/faqsBanner'));

const FAQ = (props: any) => {
  const headerFooterData = useContext(HeaderFooterContext);
  const { headerFooter } = headerFooterData;

  const { locale }: any = useRouter();

  const isContext = !!headerFooter[0];

  const getContextData = async () => {
    let defaultBrand = BRAND_NAME_EN;
    if (locale === 'fr') defaultBrand = BRAND_NAME_FR;
    const contextData = await SetBrandsContext(defaultBrand, locale);
    const brands = contextData?.data;
    headerFooterData.setHeaderFooterData(brands);
  };

  useEffect(() => {
    getContextData();
  }, [isContext, locale]);

  const { faqData, faqBannerData } = props;
  const faqTitle = faqBannerData?.attributes?.Title;
  const router = useRouter();
  const seoProps = getSEOProps(faqBannerData?.attributes?.SEO, router);
  return (
    <div className="sv-page-content FAQ-wrapper">
      <NextSeo {...seoProps} />
      <CanonicalURL />
      <FaqsBanner faqBannerData={faqBannerData}></FaqsBanner>
      <AskedQuestions
        faqData={faqData}
        faqTitle={faqTitle}
        hostUrl={props?.hostUrl}
      ></AskedQuestions>
    </div>
  );
};

export async function getServerSideProps(props: any) {
  const host = props?.req?.headers?.host;
  const locale = props?.locale;
  const hostUrl = `${host}/${locale}`;
  let brand = BRAND_NAME_EN;
  let defaultLink = FAQ_EN;
  let storageName = SELF_STORAGE_FAQ;
  if (locale === 'fr') {
    brand = BRAND_NAME_FR;
    defaultLink = FAQ_FR;
    storageName = SELF_STORAGE_FAQ_FR;
  }

  const faqRes = await getFaqsData(brand, storageName, locale);

  const faqData = (await faqRes?.data) || null;

  const faqBannerRes = await getInnerPagesWithDefaultLocale(
    defaultLink,
    brand,
    locale
  );

  const faqBannerData = (await faqBannerRes?.data?.data[0]) || null;

  return {
    props: {
      faqData,
      faqBannerData,
      hostUrl,
    },
  };
}

export default FAQ;
